import React from 'react';
import {
  CheckCircle,
  RadioButtonUnchecked,
  Error,
  Schedule,
  Build,
  Science,
} from '@mui/icons-material';

/**
 * Get the appropriate icon for an environment status
 */
export const getEnvironmentStatusIcon = (status: string) => {
  switch (status) {
    case 'idle':
    case 'ready':
      return <CheckCircle color="success" />;
    case 'deploying':
      return <Schedule color="primary" />;
    case 'preparing':
      return <Build color="info" />;
    case 'testing':
      return <Science color="info" />;
    case 'deployed':
      return <CheckCircle color="success" />;
    case 'failed':
      return <Error color="error" />;
    default:
      return <RadioButtonUnchecked />;
  }
};

/**
 * Get the appropriate color for an environment status
 */
export const getEnvironmentStatusColor = (status: string): 'success' | 'warning' | 'error' | 'default' | 'primary' | 'info' => {
  switch (status) {
    case 'idle':
    case 'ready':
    case 'deployed':
      return 'success';
    case 'deploying':
      return 'primary';
    case 'preparing':
    case 'testing':
      return 'info';
    case 'failed':
      return 'error';
    default:
      return 'default';
  }
};

/**
 * Get the appropriate icon for a deployment status
 */
export const getDeploymentStatusIcon = (status: string) => {
  switch (status) {
    case 'success':
      return <CheckCircle color="success" />;
    case 'failed':
      return <Error color="error" />;
    case 'in_progress':
    case 'pending':
      return <Schedule color="warning" />;
    default:
      return <RadioButtonUnchecked />;
  }
};

/**
 * Get the appropriate color for a deployment status
 */
export const getDeploymentStatusColor = (status: string): 'success' | 'warning' | 'error' | 'default' => {
  switch (status) {
    case 'success':
      return 'success';
    case 'failed':
      return 'error';
    case 'in_progress':
    case 'pending':
      return 'warning';
    default:
      return 'default';
  }
};

/**
 * Create navigation handlers for environment-related pages
 */
export const createEnvironmentNavigationHandlers = (navigate: (path: string) => void) => ({
  /**
   * Navigate to environment detail page
   */
  handleEnvironmentDetailClick: (environmentId: string) => {
    navigate(`/environment/${environmentId}`);
  },

  /**
   * Navigate to PR or main branch page based on deployment info
   */
  handleSourceClick: (prNumber: number | null, branch: string) => {
    if (prNumber) {
      navigate(`/pull-request/${prNumber}`);
    } else {
      navigate('/main-branch');
    }
  },

  /**
   * Navigate to deployment detail page
   */
  handleDeploymentClick: (deploymentId: string) => {
    navigate(`/deployment/${deploymentId}`);
  },

  /**
   * Navigate back to environments list
   */
  handleBackToEnvironments: () => {
    navigate('/environments');
  },
});




